import { Pipe, PipeTransform } from '@angular/core';
import { InvestmentReqRes } from 'src/app/dashboard/models/investment.model';
import { getStatus, InvestmentStatusModel } from './investor-list.utils';

@Pipe({ name: 'investmentStatusFilter'})
export class InvestmentStatusFilterPipe implements PipeTransform {
  transform(
    investments: InvestmentReqRes[] = [],
    selectedStatusKey: InvestmentStatusModel[] | null
  ): InvestmentReqRes[] {
    if (!investments || !selectedStatusKey) return investments;

    const res = investments.filter(investment => {
      const status = getStatus(investment);
      return selectedStatusKey.some(selectedStatus => selectedStatus.key === status.key);
    });

   return res.length ? res : [];
  }
}
